export const SET_CURRENT_ROOM = "SET_CURRENT_ROOM";
export const SET_IS_STREAMER = "SET_IS_STREAMER";
export const SET_PARTICIPANTS = "SET_PARTICIPANTS";
export const SET_SHOW_LOADING_OVERLAY = "SET_SHOW_LOADING_OVERLAY";
export const SET_ONLY_AUDIO = "SET_ONLY_AUDIO";